





























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { RelatedProductInterface } from '@plugin/Common/interfaces/related-products/related-product.interface'

declare global {
  interface Window {
    storeSettings: any
  }
}

@Component
export default class RelatedProductCardComponent extends Vue {
  @Getter('products/selectedCategoryName') selectedCategory
  @Getter('cart/cartItemSubCategory') selectedSubCategory
  @Prop({ default: null })
  product: RelatedProductInterface

  public productImageHeight = 160

  get hidePricing(): boolean {
    return window.storeSettings?.HidePricingOnPromotionalProductTiles
  }

  get metaText(): string | null {
    let text = ''
    if (this.product?.metaTitle)
      text = this.product.metaTitle

    if (this.product?.price != null && !this.hidePricing)
      text += text ? ` $${this.formatPrice(this.product.price)}` : `$${this.formatPrice(this.product.price)}`

    return text || null
  }
  
  get outputPrice(): string {
    return this.product?.price ? `$${this.formatPrice(this.product.price)}` : ''
  }

  get productUrl(): string {
    return this.product.url
  }

  get useLegacy(): boolean {
    return this.product.useLegacy
  }

  get cardImage(): string {
    return  `linear-gradient(0deg, rgb(0 0 0 / 10%) 0%, rgb(0 0 0 / 10%) 100%), center / cover url(\"${this.product.imageUrl}\"), lightgray -155.562px -34.952px / 215.822% 128.338% no-repeat`
  }

  formatPrice(value: number): string {
    if (!value) {
      return '0.00'
    }
    const val = (value / 1).toFixed(2)
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }

  async sendGA4RelatedProductsEvent() {
    let listId = 'related_products'
    let listName = 'Related Products'
    await this.$store.dispatch('cart/persistTempGA4Data', { id: listId, name: listName })

    let productItems = [
      {
        item_list_id: listId,
        item_list_name: listName,
        item_id: this.product.id,
        item_name: this.product.title,
        coupon: null,
        discount: null,
        index: 0,
        item_brand: null,
        item_category: this.selectedCategory,
        item_category2: this.selectedSubCategory,
        item_category3: null,
        item_variant: null,
        location_id: null,
        price: this.product.price,
        quantity: null,
        sku: null,
      },
    ]
    this.sendGA4AnalyticsEvent({
      evtName: 'select_item',
      products: productItems,
    })
  }

  @Action('global/sendGA4AnalyticsEvent') sendGA4AnalyticsEvent
}
